import { createContext } from "react";

export const ViewOfferContext = createContext();
export const CreateOfferContext = createContext();
